module.exports = __webpack_public_path__ + "img/video-left.cda680e6.png";